module.exports = __webpack_public_path__ + "img/construction_on_melody_lane.4da05b38.jpg";